import React, {useEffect, useState} from 'react';
import ReactJson from "react-json-view";

import { Button } from "player-components";
import { useDispatch } from "react-redux";
import platform from "platform";

import { addNotificationAsync, setFeedbackModalVisible } from "../../features/ui/uiSlice";
import { clearAudioStorage } from "../../services/assetStore";
import { persistor } from "../../store";
import { store } from "../../store";

import PackageJSON from "../../../package.json";
import ComponentsPackageJson from 'player-components/package.json';

const Experiments = () => {
  const dispatch = useDispatch();

  const [storageConsumption, setStorageConsumption] = useState(0);

  const clearLocalStorage = async () => {
    await persistor.purge();
    await clearAudioStorage();
    localStorage.clear();
    window.location.reload();
  };

  useEffect(async () => {
    const usage = await navigator.storage.estimate();
    setStorageConsumption(usage);
  },[]);

  return (
    <div className="flex flex-col space-y-3 dark:text-white px-3 py-3 overflow-y-auto">
      <p>Below are various tools used while developing the application</p>
      <Button
        type="primary"
        onClick={() => {
          dispatch(
            addNotificationAsync({
              title: Date.now(),
              text: "Test content",
              type: "positive",
            })
          );
        }}
      >
        Add notification
      </Button>

      <Button onClick={clearLocalStorage} type="primary">
        Wipe local application state
      </Button>

      <Button onClick={()=>{
        dispatch(
          setFeedbackModalVisible(true)
        );
      }} type="primary">
       Show feedback Modal
      </Button>
      <p>player-application version: v{PackageJSON.version}</p>
      <p>player-components version: v{ComponentsPackageJson.version}</p>
      {storageConsumption && <div>
        <p>IndexedDB Available: {(storageConsumption.quota/1000000).toFixed(2)}MB</p>
      <p>IndexedDB Usage: {(storageConsumption.usage/1000000).toFixed(2)}MB</p>
      </div>}

      <div>
        <h4>Application state:</h4>
        <ReactJson collapsed={true} theme="monokai" src={store.getState()} />
        <h4 className="mt-4">Platform:</h4>
        <ReactJson collapsed={false} theme="monokai" src={platform} />
        <h4 className="mt-4">Session error:</h4>
        <span style={{color: 'red'}}>{store.getState().session?.error}</span>
      </div>
      <p><br /><br /><br /></p>
    </div>
  );
};

export default Experiments;
